import type { ReactNode } from 'react';
import { MomSalaryReportPage } from '../momSalaryReport';
import { MoMSalesReportPage } from '../momSalesReport';
import { RevenueReportPage } from '../revenueReport';
import { BankAccountBalanceReportPage } from '../bankAccountBalanceReport';
import { ExpenseCategoryReportPage } from '../expenseCategoryReport';
import { FinanceEmailInboxPage } from '../finance-email-inbox';

const customGridPages: Record<string, () => ReactNode> = {
  MomSalaryReportGridItem: () => <MomSalaryReportPage />,
  MomSalesReportGridItem: () => <MoMSalesReportPage />,
  RevenueReportGridItem: () => <RevenueReportPage />,
  BankAccountBalanceReportGridItem: () => <BankAccountBalanceReportPage />,
  ExpenseCategoryReportGridItem: () => <ExpenseCategoryReportPage />,
  FinanceEmailInboxGridItem: () => <FinanceEmailInboxPage />,
};

export const resolveCustomGridPage = (dataSource?: string): ReactNode =>
  dataSource ? (customGridPages[dataSource]?.() ?? null) : null;
